import { Chip, type ChipProps } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

import React from 'react'

type Props = {
  icon: React.ReactElement
  label: string
  color?: 'primary' | 'secondary'
  sx?: SxProps<Theme>
} & Omit<ChipProps, 'icon' | 'label' | 'color' | 'sx' | 'size' | 'ref'>

export const ImageBadge = React.forwardRef<HTMLDivElement, Props>(function ImageBadge(
  { icon, label, color = 'primary', sx, ...rest },
  ref,
) {
  return (
    <Chip
      ref={ref}
      icon={icon}
      label={label}
      size="small"
      color={color}
      sx={[
        {
          maxWidth: '100%',
          height: 20,
          fontWeight: 700,
          fontSize: '0.6875rem',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...rest}
    />
  )
})
